import axios from 'axios'
import { normalizePhone } from './validators'

var buildInquiryPayload = function (formData) {
  return {
    inquiry: {
      desired_prefecture: formData.desired_prefecture,
      job_change_timing: formData.job_change_timing || '',
      desired_job: formData.desired_job,
      desired_workplace_type: formData.desired_workplace_type || '',
      experience_year: formData.experience_year,
      name: formData.name,
      birthyear: formData.birthyear,
      phone: normalizePhone(formData.phone),
      email: formData.email,
      message: formData.message || ''
    }
  }
}

var buildAddingQuestionPayload = function (formData) {
  return {
    adding_question: {
      current_salary: formData.current_income || '',
      desired_salary: formData.desired_income || '',
      remarks: formData.other_inquiry || '',
      experience_jobs: formData.experience_jobs || [],
      interview_dates: formData.lp_interview_dates || []
    }
  }
}

export var submitInquiry = function (formData) {
  var payload = buildInquiryPayload(formData)
  return axios.post('/api/v1/lp/inquiries', payload).then(function (res) { return res.data })
}

export var submitAddingQuestion = function (inquiryId, formData) {
  var payload = buildAddingQuestionPayload(formData)
  return axios.post('/api/v1/lp/inquiries/' + inquiryId + '/adding_questions', payload)
    .then(function (res) { return res.data })
    .catch(function (error) {
      if (error.response && error.response.data) return error.response.data
      throw error
    })
}
